import React from "react";
import Header from "./Header/Header";
import LeftSideBar from "./LeftSideBar/LeftSideBar";
import { Grid, Box } from "@mui/material";
import AdministratorHeader from "./Header/AdministratorHeader";
import ExtractionDetailTable from "./ExtractionDetailTable";
import constantValues from "../constants/constantValues";
export default function ExtractionDetails() {
  const {
    PARAMETER_NAME,
    VALUE,
    PDF_NAME,
    OUT_OF_RANGE,
    PAGE_NO,
    EXTRACTION_DETAILS,
  } = constantValues;

  let header = [PARAMETER_NAME, VALUE, PDF_NAME, OUT_OF_RANGE, PAGE_NO];

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader text={EXTRACTION_DETAILS} />
            <Grid item md={12}>
              <ExtractionDetailTable header={header} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
